/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Para2Inputs */

const zh_landing_audience_para2 = /** @type {(inputs: Landing_Audience_Para2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们为希望少花时间备课、多花时间真正教学的老师和导师打造了 StudyOS。从生成测验到跟踪学生进度，一切都设计得简单、迅速、真正有用。`)
};

const en_landing_audience_para2 = /** @type {(inputs: Landing_Audience_Para2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We created StudyOS for teachers and tutors who want to spend less time preparing materials and more time actually teaching. From generating quizzes to tracking student progress, everything is designed to be simple, fast, and genuinely helpful.`)
};

const es_landing_audience_para2 = /** @type {(inputs: Landing_Audience_Para2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creamos StudyOS para docentes y tutores que quieren pasar menos tiempo preparando materiales y más tiempo enseñando de verdad. Desde generar cuestionarios hasta seguir el progreso, todo está diseñado para ser simple, rápido y genuinamente útil.`)
};

/**
* | output |
* | --- |
* | "We created StudyOS for teachers and tutors who want to spend less time preparing materials and more time actually teaching. From generating quizzes to tracki..." |
*
* @param {Landing_Audience_Para2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_para2 = /** @type {((inputs?: Landing_Audience_Para2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Para2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_para2(inputs)
	if (locale === "en") return en_landing_audience_para2(inputs)
	return es_landing_audience_para2(inputs)
});